import { alignCenter, alignLeft, alignRight, bindKeymapWithCommand } from '@atlaskit/editor-common/keymaps';
import { keymap } from '@atlaskit/editor-prosemirror/keymap';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { changeAlignment } from '../commands';
export function keymapPlugin() {
  var list = {};
  bindKeymapWithCommand(alignLeft.common, changeAlignment('start'), list);
  if (getBooleanFF('platform.editor.text-alignment-keyboard-shortcuts')) {
    bindKeymapWithCommand(alignCenter.common, changeAlignment('center'), list);
    bindKeymapWithCommand(alignRight.common, changeAlignment('end'), list);
  }
  return keymap(list);
}